// extracted by mini-css-extract-plugin
export default {"message":"Mensagem_message__Dl7gT","sucess":"Mensagem_sucess__PSGt+","error":"Mensagem_error__0U83W"};